import { configureStore} from '@reduxjs/toolkit';
import authenticationReducer from '../auth/AuthenticationSlice';
import createSagaMiddleware from '@redux-saga/core';
import rootSaga from '../core/RootSaga';
import generalErrorSlice from '../helper/general-error/GeneralErrorSlice';
import confirmationSlice from '../helper/confirmation-modal/confirmationSlice';
import estoqueSlice from '../estoque/EstoqueSlice';
import clientesSlice from '../clientes/ClientesSlice';
import relatorioSlice from '../relatorios/RelatorioSlice';

const sagaMiddleWare = createSagaMiddleware();

export const store = configureStore({
  middleware : (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleWare),
  reducer: {
    auth: authenticationReducer,
    generalError : generalErrorSlice,
    confirmation : confirmationSlice,
    estoque : estoqueSlice,
    clientes: clientesSlice,
    relatorio: relatorioSlice
  },
});

sagaMiddleWare.run(rootSaga);
